export default __webpack_public_path__ + "static/media/betterlesson.44cd41df.svg";